<template>
	<LineChartGenerator
		:styles="styles"
		:plugins="plugins"
		:chart-id="chartId"
		:chart-data="chartData"
		:css-classes="cssClasses"
		class="width-100 height-100"
		:chart-options="chartOptions"
		:dataset-id-key="datasetIdKey"
	/>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, Filler } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, Filler);
export default {
	name: 'LineChart',
	components: { LineChartGenerator },
	props: {
		cssClasses: { type: String, default: '' },
		plugins: { type: Array, default: () => [] },
		chartData: { type: Object, required: true },
		styles: { type: Object, default: () => ({}) },
		chartId: { type: String, default: 'line-chart' },
		datasetIdKey: { type: String, default: 'label' },
		chartOptions: { type: Object, default: () => ({}) },
	},
};
</script>
